import { DELETE_RING_GROUP } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const deleteRingGroup = async (id) => {
  try {
    const resp = await apiClient.delete(DELETE_RING_GROUP(id), {});
    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
